import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import strings from 'utils/strings';
import {DEVELOPMENT, ENVIRONMENT} from 'constants/index';
import {updateObject} from 'utils/reducerUtils';
import AudioPlayer from 'components/AudioPlayer';

import Countdown from 'components/Countdown';

import noData from './languages/no-data.json';
import nnData from './languages/nn-data.json';

import * as noTestData from './languages/no-test-data';
import * as nnTestData from './languages/nn-test-data';

import allAnswers from './languages/noAnswers.json';

const tutorialObj = {
	no: noData,
	nn: nnData,
};

const testObj = {
	no: noTestData,
	nn: nnTestData,
};
const SHOW_OPTIONS_IMMEDIATELY = ENVIRONMENT === DEVELOPMENT;

let timeFlag = false;
class Test extends React.Component {
	constructor(props) {
		super(props);
		const grade = Number(this.props.candidateGrade);
		const results = {};
		const checkData = [];
		this.assignments = tutorialObj[strings.getLanguage()];
		this.falseAnswersCheck = allAnswers;
		this.test = testObj[strings.getLanguage()];
		this.dinTurSound = this.test.dinTurSound;
		for (const assignment of this.assignments) {
			results[assignment.id] = '';
		}
		for (let i = 0; i < this.falseAnswersCheck.length; i++) {
			checkData.push({
				id: i + 1,
				isTaken: this.falseAnswersCheck[i].isTaken,
				value: this.falseAnswersCheck[i].value,
				isCorrect: this.falseAnswersCheck[i].isCorrect,
			});
		}

		this.state = {
			results,
			checkData,
			timeRanOut: false,
			counter: 1,
			limit: 6,
			hideComment: false,
			showTestPanel: true,
			scrollPosition: 0,
			timeOut: false,
			nextQuestion: false,
			bruteFinish: false,
			imageClass: 'imgItem',
			wrongAnswerDetected: false,
			correctAnswerDetected: false,
			halfAnswerDetected: false,
			answerArray: [],
			showOptions: SHOW_OPTIONS_IMMEDIATELY,
			selectedGroupId: null,
			audioPlayedOnce: {},
			audioIsPlaying: true,
			audioRestartNonce: 0,
			audioRestartedOnce: false,
			audioControlsDisabled: false,
			singleAssignment: {
				1: this.test.assignment1,
				2: this.test.assignment2,
				3: this.test.assignment3,
				4: this.test.assignment4,
				5: this.test.assignment5,
				6: this.test.assignment6,
				7: this.test.assignment7,
				8: this.test.assignment8,
				9: this.test.assignment9,
				10: this.test.assignment10,
				11: this.test.assignment11,
				12: this.test.assignment12,
				13: this.test.assignment13,
				14: this.test.assignment14,
				15: this.test.assignment15,
				16: this.test.assignment16,

				17: this.test.assignment17,
				18: this.test.assignment18,
				19: this.test.assignment22,
			},
		};

		this.audioRefs = {};

		this.audioRefs = {};

		this.audioRefView = React.createRef();
		this.gridRef = React.createRef();
	}

	handleImageClick(item, assignmentId) {
		const {answerArray = []} = this.state;
		if (answerArray.includes(item.word)) {
			return;
		}
		const updatedAnswerArray = [...answerArray, item.word];
		item.currentClass = 'imgItem__clicked';
		this.setResults(assignmentId, {
			isCorrect: true,
			isAnswered: true,
			answerArray: updatedAnswerArray,
		});

		this.setState({
			answerArray: updatedAnswerArray,
		});
	}

	recordAnswerSetSyle(assignmentArray, groupId, totalExpectedAnswers) {
		const {counter, answerArray} = this.state;
		const currentAssignment = assignmentArray[0];
		const {choices, order, id} = currentAssignment;
		let selectedWord = null;
		for (const choice of choices) {
			for (const group of choice.choiceGroup) {
				if (
					group.groupId === groupId &&
					!answerArray.includes(group.word)
				) {
					selectedWord = group.word;
					group.currentClass = 'imgItem__selected';
					break;
				}
			}
			if (selectedWord) break;
		}
		if (!selectedWord) return;

		const updatedAnswerArray = [...answerArray, selectedWord];
		const isFinalStep = updatedAnswerArray.length === totalExpectedAnswers;
		const singleAssignment = {...this.state.singleAssignment};
		singleAssignment[counter] = assignmentArray;
		this.setState({
			answerArray: updatedAnswerArray,
			singleAssignment,
		});
		if (isFinalStep) {
			const {correct} = this.compareAnswers(order, updatedAnswerArray);
			const isCorrect = correct === totalExpectedAnswers;
			const result = {
				isAnswered: true,
				isCorrect,
				answerArray: updatedAnswerArray,
			};
			this.setResults(id, result);
		}
	}

	compareAnswers(correctAnswer, userAnswer) {
		let correct = 0;
		for (let i = 0; i < correctAnswer.length; i++) {
			if (correctAnswer[i] === userAnswer[i]) {
				correct++;
			}
		}
		return {correct};
	}

	preloadImages = (urls = []) => {
		const tasks = urls.map((src) => {
			const img = new Image();
			img.src = src;
			return img.decode?.().catch(() => {});
		});
		return Promise.all(tasks);
	};

	markAudioPlayedOnce(step) {
		this.setState((s) => ({
			audioPlayedOnce: {...s.audioPlayedOnce, [step]: true},
		}));
	}

	componentDidMount() {
		this.preloadCurrent();
		this.setState({audioIsPlaying: true});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.counter !== this.state.counter) {
			this.preloadCurrent();
			this.setState({
				audioIsPlaying: true,
				audioRestartNonce: 0,
				audioRestartedOnce: false,
				audioControlsDisabled: false,
			});
		}
	}

	preloadCurrent() {
		if (this.state.counter < 19) {
			const [assignment] =
				this.state.singleAssignment[this.state.counter];
			const urls = assignment.choices.flatMap((c) =>
				c.choiceGroup.map((g) => g.img)
			);
			this.preloadImages(urls);
		}
	}

	setResults(id, value) {
		const {results, checkData, counter} = this.state;

		const updatedCheckData = checkData.map((entry) => {
			if (entry.id === counter) {
				return {
					...entry,
					isTaken: true,
					isCorrect: value.isCorrect,
				};
			}
			return entry;
		});

		this.setState(
			(prevState) => ({
				results: updateObject(prevState.results, {[id]: value}),
				checkData: updatedCheckData,
				scrollPosition: window.pageYOffset,
				timeOut: false,
			}),
			() => {
				this.updateCount('userAction');
			}
		);
	}

	updateCount(origin) {
		timeFlag = false;
		if (origin === 'timer') {
			this.storeUnAnswered();
			this.props.onShowAvatar(true);
		} else {
			this.setState((prevState) => ({
				counter: prevState.counter + 1,
				hideComment: false,
				timeOut: false,
				answerArray: [],
				showTestPanel: true,
				showOptions: SHOW_OPTIONS_IMMEDIATELY,
			}));
			this.props.onShowAvatar(false);
		}
		/* this.checkForConsecutiveMistake(); */
	}

	storeUnAnswered() {
		const {checkData, counter, results} = this.state;
		const updatedCheckData = checkData.map((entry) => {
			if (entry.id === counter) {
				return {...entry, isTaken: true};
			}
			return entry;
		});
		const updatedResults = updateObject(results, {
			[counter]: {
				isCorrect: false,
				isAnswered: false,
			},
		});

		this.setState((prevState) => ({
			results: updatedResults,
			counter: prevState.counter + 1,
			hideComment: false,
			timeOut: false,
			showTestPanel: false,
			checkData: updatedCheckData,
			nextQuestion: true,
			answerArray: [],
		}));
	}
	scrollToTop = () => {
		if (this.testRef) {
			this.testRef.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
	};

	toggleTimeout(origin) {
		timeFlag = false;
		if (origin === 'audioAction') {
			this.setState({
				timeOut: true,
			});
		}

		if (origin === 'userAction') {
			timeFlag = false;
			this.setState({
				timeOut: false,
			});
		}
	}

	checkForConsecutiveMistake() {
		const {checkData} = this.state;

		const maxMistakeThreshold = 5;
		const iterator = [];
		let checkConsitencyFlag = 0;
		for (let i = 0; i < checkData.length; i++) {
			if (checkData[i].isTaken && !checkData[i].isCorrect) {
				iterator.push(i);
			}
		}
		if (iterator.length >= maxMistakeThreshold) {
			for (let i = 0; i < iterator.length; i++) {
				if (iterator[i + 1] !== 'undefined') {
					if (iterator[i + 1] - iterator[i] === 1) {
						checkConsitencyFlag = checkConsitencyFlag + 1;
						if (checkConsitencyFlag >= maxMistakeThreshold) {
							this.setState({
								bruteFinish: true,
							});
							break;
						}
					} else {
						checkConsitencyFlag = 0;
					}
				}
			}
		}
	}

	render() {
		const {onNextStep, isSendingTestResults} = this.props;

		const {results, timeRanOut, bruteFinish, singleAssignment} = this.state;
		const isNextButtonVisible =
			this.state.counter === 19 || timeRanOut || bruteFinish;

		let filteredAssignments;

		if (timeRanOut) {
			filteredAssignments = singleAssignment[this.state.counter].filter(
				(assignment) => {
					return results[assignment.id];
				}
			);
		} else {
			filteredAssignments = this.assignments;
		}

		const disableWrapperProps = this.state.audioControlsDisabled
			? {
					style: {pointerEvents: 'none'},
					'aria-disabled': 'true',
					tabIndex: -1,
			  }
			: {};

		return (
			<div className="lit-test" style={{marginTop: '-20px'}}>
				{this.state.timeOut && (
					<div
						className="lit-infobar"
						key={singleAssignment[this.state.counter]}
					>
						<Countdown
							duration={15}
							onComplete={() => {
								this.updateCount('timer');
							}}
						/>
					</div>
				)}

				<div
					className="lit-sprakforstaelse"
					ref={(el) => (this.testRef = el)}
				>
					<div className="lit-sprakforstaelse lit-sprakforstaelse__tutorial">
						{singleAssignment[this.state.counter].map(
							(assignment) => {
								const {id, choices, order} = assignment;

								let audioPlayerRef;

								if (
									this.state.showTestPanel &&
									this.state.counter < 19 &&
									!this.state.bruteFinish
								) {
									return (
										<div
											className="lit-illustrations-wrapper"
											key={id}
										>
											<div className="lit-single-word">
												{/* <span className="lit-input__label lit-input__label--count">
													{id}
												</span> */}
												<p>
													<p className="audio-instruction">
														<span className="audio-with-step">
															{!this.state
																.audioPlayedOnce[
																this.state
																	.counter
															] && (
																<span
																	{...disableWrapperProps}
																	onPointerDownCapture={(
																		e
																	) => {
																		const {
																			audioIsPlaying,
																			audioRestartedOnce,
																			audioControlsDisabled,
																		} =
																			this
																				.state;

																		if (
																			!audioControlsDisabled &&
																			audioIsPlaying &&
																			!audioRestartedOnce
																		) {
																			e.preventDefault();
																			e.stopPropagation();

																			this.setState(
																				(
																					s
																				) => ({
																					audioRestartNonce:
																						s.audioRestartNonce +
																						1,
																					audioRestartedOnce: true,
																					audioControlsDisabled: true,
																				})
																			);
																		}
																	}}
																	onKeyDownCapture={(
																		e
																	) => {
																		if (
																			this
																				.state
																				.audioControlsDisabled
																		) {
																			e.preventDefault();
																			e.stopPropagation();
																		}
																	}}
																>
																	<AudioPlayer
																		inline
																		id={
																			singleAssignment[
																				this
																					.state
																					.counter
																			].id
																		}
																		key={`audio-${this.state.counter}-${this.state.audioRestartNonce}`}
																		autoplay
																		onErrorPlay={() => {
																			console.log(
																				'Something went wrong'
																			);
																			this.setState(
																				{
																					showOptions: true,
																					audioIsPlaying: false,
																				}
																			);
																		}}
																		onComplete={() => {
																			this.toggleTimeout(
																				'audioAction'
																			);

																			if (
																				this
																					.audioRefView
																					.current
																			) {
																				this.audioRefView.current.scrollIntoView(
																					{
																						behavior:
																							'smooth',
																						block: 'start',
																					}
																				);
																			}

																			this.setState(
																				{
																					showOptions: true,
																					audioIsPlaying: false,
																				}
																			);
																			this.markAudioPlayedOnce(
																				this
																					.state
																					.counter
																			);
																		}}
																		onPause={() => {
																			/* 	this.toggleTimeout(
																			'audioAction'
																		); */

																			this.setState(
																				{
																					audioIsPlaying: false,
																				}
																			);
																		}}
																		ref={(
																			ref
																		) => {
																			audioPlayerRef =
																				ref;
																		}}
																		refs={
																			this
																				.audioRefs
																		}
																		src={
																			assignment.mainSound
																		}
																	/>
																</span>
															)}
															<span
																className="tutorial-step-badge"
																aria-label={`Trinn ${this.state.counter} av 18`}
															>
																<span className="current">
																	{
																		this
																			.state
																			.counter
																	}
																</span>
																<span className="sep">
																	av
																</span>
																<span className="total">
																	18
																</span>
															</span>
														</span>
													</p>
												</p>
											</div>
											<div
												className="lit-image-grid-test"
												ref={this.audioRefView}
											>
												{choices.map((choice, i) => {
													const {choiceGroup} =
														choice;
													return (
														// eslint-disable-next-line react/jsx-key
														<div>
															{this.state
																.showOptions && (
																<div className="lit-illustrations-list">
																	<br />
																	{choiceGroup.map(
																		(
																			group
																		) => {
																			const isSelected =
																				this.state.answerArray.includes(
																					group.word
																				);
																			const selectionIndex =
																				this.state.answerArray.indexOf(
																					group.word
																				);
																			const idWord =
																				i +
																				group.word;
																			const {
																				groupId,
																			} =
																				group;
																			const {
																				currentClass,
																			} =
																				group;
																			return (
																				<span
																					className="lit-word"
																					key={
																						idWord
																					}
																				>
																					<span className="imgItemWrapper">
																						{[
																							16,
																							17,
																							18,
																						].includes(
																							this
																								.state
																								.counter
																						) &&
																							isSelected && (
																								<span className="imgItem__badge">
																									{selectionIndex +
																										1}
																								</span>
																							)}
																						<img
																							onClick={() => {
																								this.recordAnswerSetSyle(
																									singleAssignment[
																										this
																											.state
																											.counter
																									],
																									groupId,
																									order.length
																								);
																							}}
																							className={
																								currentClass
																							}
																							src={
																								group.img
																							}
																							alt={
																								group.word
																							}
																						/>
																					</span>
																				</span>
																			);
																		}
																	)}
																</div>
															)}
														</div>
													);
												})}
											</div>
										</div>
									);
								}
							}
						)}
					</div>
				</div>

				{isNextButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() => onNextStep(results)}
					>
						{strings.done}
					</button>
				)}
				{this.state.nextQuestion &&
					this.state.counter < 19 &&
					!this.state.bruteFinish && (
						<button
							className="lit-btn bg-primary"
							onClick={() => {
								this.setState({
									showTestPanel: true,
									nextQuestion: false,
									showOptions: SHOW_OPTIONS_IMMEDIATELY,
								});
								this.props.onShowAvatar(false);
							}}
							disabled={isSendingTestResults}
						>
							{'Neste'}
						</button>
					)}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

export default connect(mapStateToProps)(Test);
